import { SingleAttachmentAttributeVisualizerComponent } from "../../components/shared/single-attachment-attribute-visualizer/single-attachment-attribute-visualizer.component";
import { BaseEntityAttribute } from "./base-entity-attribute";

export class SingleAttachmentEntityAttribute extends BaseEntityAttribute {
  type?: string;
  url?: string;

  constructor(attributeName: string, mapEntityId: string, type?: string, order: number = 0) {
    super(attributeName, mapEntityId, true, true, order);
    this.type = type;
  }

  override getDirective(): any {
    return {
      component: SingleAttachmentAttributeVisualizerComponent,
      inputs: { mapentityid: this.mapEntityId, type: this.type ?? '', attachmentUrl: this.url ?? '' }
    };
  }

  getUrl(): string | undefined {
    return this.url;
  }
}